// extracted by mini-css-extract-plugin
export default {"zoomControls":"yba-z","zoomControlButton":"zba-z","zoomBanner":"Aba-z","bannerButton":"Bba-z","imageButton":"Cba-z","zoom":"Dba-z","zoomContent":"Eba-z"};